import React from 'react';

import { ShowroomFilterTree, ShowroomFilterTreeValue } from 'Types/showroom';

import { useIsShowroomUserView } from 'lib/showroom';

import Divider from '@material-ui/core/Divider';

import { HEADER_HEIGHT } from 'components/Showroom/Content/Header/styles';
import { SHOWROOM_LAYOUT_HEADER_HEIGHT } from 'components/Showroom/Layout/styles';

import ShowroomContentFilterTree from '../FilterTree';
import { useStyles } from './styles';

export type ComponentProps = {
	selectedFilters: string[];
	sortedFilters: ShowroomFilterTree[];
	onFilterToggle(value: ShowroomFilterTreeValue): void;
	containerHeight: number;
};

const ShowroomFilterTreeContainer = (props: ComponentProps) => {
	const { selectedFilters, sortedFilters, onFilterToggle, containerHeight } = props;

	const isUserView = useIsShowroomUserView();

	const topOffset = isUserView ? HEADER_HEIGHT : HEADER_HEIGHT + SHOWROOM_LAYOUT_HEADER_HEIGHT;
	const classes = useStyles({ fileTreeMaxHeight: containerHeight, topOffset });

	return (
		<div className={classes.showroomFilterTreeInnerWrapper}>
			{sortedFilters.map((filterTree, index, arr) => (
				<React.Fragment key={filterTree.name}>
					<ShowroomContentFilterTree tree={filterTree} onFilterToggle={onFilterToggle} selectedFilters={selectedFilters} />
					{index !== arr.length - 1 && <Divider className={classes.treeDivider} />}
				</React.Fragment>
			))}
		</div>
	);
};

export default React.memo(ShowroomFilterTreeContainer);
